import React from 'react'
import { round } from '../utils/number'
import SlopeSlider from './SlopeSlider'
import styles from './SlopeGraf.module.css'

class SlopeGraf extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (value) {
    const { size, scale } = this.props
    const dv = scale * size
    const dy = value + dv + 15
    const slope = (size - dy / scale) / 10
    this.props.onChange(round(slope, 0))
  }

  render () {
    const { size, scale, slope, filling, dnIndex } = this.props
    const dv = scale * size
    const dy = scale * (size - (slope * 10))
    const d = dv * 0.1 * (1 + dnIndex * 0.5)
    const f = d * filling
    const fillColor = filling > 1 ? 'red' : '#9dd6f2'
    const txtX = dv / 10
    const txtY = dv - (dv - (dv / 3))
    const txtT = `rotate(-90 ${txtX} ${txtY})`
    return (
      <div style={{ 'width': dv, 'height': dv }}>
        <svg width={dv} height={dv} className={styles.slopeSvg}>
          <polygon points={`0,${dv} ${dv},${dy} ${dv},${dy - f} 0,${dv - f}`} fill={fillColor} />
          <line x1='0' y1={dv} x2={dv} y2={dy} stroke='black' strokeWidth='2' />
          <line x1='0' y1={dv - d} x2={dv} y2={dy - d} stroke='black' strokeWidth='2' />
        </svg>
        <SlopeSlider top={Math.max(-1 * dv - 15, dy - dv - 15)} height={dv} onChange={this.handleChange}
          left={dv - 15} />
      </div>
    )
  }
}

SlopeGraf.defaultProps = {
  size: 1000,
  scale: 0.25,
  slope: 20,
  filling: 0.2,
  dnIndex: 1
}

// SlopeGraf.propTypes = {
//   size: PropTypes.number,
//   scale: PropTypes.number,
//   slope: PropTypes.number,
//   filling: PropTypes.number,
//   dnIndex: PropTypes.number,
//   onChange: PropTypes.func
// }

export default SlopeGraf
